module.exports = __webpack_public_path__ + "static/media/lake.976499d1.png";